// extracted by mini-css-extract-plugin
module.exports = {"main":"OperationReportStyles_main__3SicW","cardSection":"OperationReportStyles_cardSection__3NoeK","flexRow":"OperationReportStyles_flexRow__L0JAb"};